const Loader = (props) => {
    return (
      <>
        <div className={`${props.vhCenter ? 'text-center vh-100 d-flex align-items-center justify-content-center': 'text-center mt-3'}`}>
            <span className="loader"></span>
        </div>
      </>
    );
  };
  export default Loader;

  
  